export default __webpack_public_path__ + "static/media/icon-toogle-menu-color-primary.dd3de4d1.svg";